import type { SchemaField } from '@doneverse/data/utils'
import { DynamicBriefForm } from '@/components/kanban/DynamicBriefForm'

const noop = () => {}

export interface SchemaPreviewProps {
  /** Live flat schema fields from the editor form. */
  fields: SchemaField[]
}

/**
 * Live preview of the brief produced by the schema currently being edited.
 * Reuses the exact renderer the end user sees (DynamicBriefForm, embedded
 * variant) so the preview matches the real result — works for both the founder
 * and doer brief schemas. Interactive so the admin can exercise conditional
 * (showWhen) logic; nothing is submitted.
 *
 * Renders body only — the surrounding chrome (header, scroll container) is
 * provided by the desktop pane or the mobile Sheet that hosts it.
 */
export function SchemaPreview({ fields }: SchemaPreviewProps) {
  const hasQuestions = fields.some((field) => field.type !== 'section')

  if (!hasQuestions) {
    return (
      <div className="rounded-lg border border-dashed border-border p-10 text-center text-sm text-muted-foreground">
        Add a field to see the brief preview.
      </div>
    )
  }

  return <DynamicBriefForm schema={fields} onSubmit={noop} variant="embedded" />
}
